import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import {
  BaseDrawerContent,
  type DrawerContentProps
} from 'reservations/base/components/BaseDrawerContent';

export type ChecklessPaymentDrawerProps = {
  showFooter?: boolean;
} & Pick<DrawerContentProps, 'headerText' | 'subheaderText' | 'handleBack'>;

export const ChecklessPaymentsDrawer = ({
  children,
  showFooter,
  ...props
}: React.PropsWithChildren<ChecklessPaymentDrawerProps>) => {
  const footer = usePreAuthFinePrint();
  return (
    <BaseDrawerContent {...props} footer={showFooter ? footer : undefined}>
      {children}
    </BaseDrawerContent>
  );
};
